import * as Response from 'src/api/google/interfaces/responses'
import { IGooglePrediction } from 'src/interfaces/map'

export const $prediction = (prediction: Response.ILocationPrediction): IGooglePrediction => ({
  description: prediction.description,
  placeId: prediction.place_id,
  types: prediction.types
})
